import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/Carousel.css';
import '../styles/EliteEffects.css';

const FeaturedCarousel = ({ products, onAddToCart }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const carouselRef = useRef(null);

  // Featured products (first 5)
  const featuredProducts = products.slice(0, 5);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % featuredProducts.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, featuredProducts.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? featuredProducts.length - 1 : prev - 1
    );
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % featuredProducts.length);
    setIsAutoPlaying(false);
  };

  const getCardPosition = (index) => {
    const diff = index - currentIndex;
    if (diff === 0) return 'center';
    if (diff === 1 || diff === -(featuredProducts.length - 1)) return 'right';
    if (diff === -1 || diff === featuredProducts.length - 1) return 'left';
    return 'hidden';
  };

  return (
    <div className="featured-carousel" ref={carouselRef}>
      <div className="carousel-header">
        <h2 className="heading-1">Wyróżnione produkty</h2>
        <p className="body-regular">Nasze najpopularniejsze produkty w premiumowej prezentacji</p>
      </div>

      <div className="carousel-container">
        <button 
          className="carousel-nav carousel-nav-left" 
          onClick={goToPrevious}
          aria-label="Poprzedni produkt"
        >
          <ChevronLeft size={24} />
        </button>

        <div className="carousel-track">
          {featuredProducts.map((product, index) => {
            const position = getCardPosition(index);
            return (
              <div
                key={product.id}
                className={`carousel-card carousel-card-${position}`}
                onClick={() => position === 'center' && onAddToCart(product)}
              >
                <div className="chrome-reflection"></div>
                <div className="carousel-card-inner">
                  <div className="carousel-image-wrapper">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="carousel-image"
                    />
                  </div>
                  <div className="carousel-info">
                    <h3 className="heading-3">{product.name}</h3>
                    <p className="body-small">{product.description}</p>
                    <div className="carousel-price glow-breathe">{product.price.toFixed(2)} zł</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button 
          className="carousel-nav carousel-nav-right" 
          onClick={goToNext}
          aria-label="Następny produkt"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      <div className="carousel-dots">
        {featuredProducts.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Przejdź do slajdu ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturedCarousel;
